export const environment = {
  production: true,
  REST_SERVICE_BASE_URL: "/srmrest/api",
   // timeout espresso in millisecondi
  SERVICE_TIMEOUT:  20000,
  // tempo di attesa in secondi per gestione presenze manuali
  PRESENZE_DELAY: 15,
  // abilitazione funzione di censimento attrezzature da parte di utenti base
  CAN_USER_ADD_EQUIPMENT: false,
  // abilitazione funzione di assegnazione/de-assegnazione attrezzature
  CAN_USER_ASSING_EQUIPMENT: false
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts